document.addEventListener("DOMContentLoaded", function () {
  const languageSelects = document.querySelectorAll(
    ".language-dropdown select",
  );

  if (!languageSelects.length) return; // Exit if no elements exist

  // Submit form when language selection changes
  languageSelects.forEach((select) => {
    select.addEventListener("change", function () {
      this.closest("form").submit();
    });
  });
});
